<template>
  <div>
    <div v-if="!editing"></div>
    <div v-else>
      <div class="row mb-4">
        <div class="col-12">
          <h5>{{ 'Assignment' | translate }}</h5>
        </div>
        <div class="col-12 mb-3">
          <QuillInputS
            name="assignment"
            display-name=""
            placeholder="Assignment here"
            :value="data.assignment.quill"
            @quillChanged="assignmentChanged"
          ></QuillInputS>
        </div>
        <div class="col-12">
          <ImageUpload
            context="component.data.assignment_img"
            :file-path="data.assignment_img"
            @uploadCompleted="storeFile('assignment_img', $event)"
            @fileDeleted="deleteFile('assignment_img')"
          ></ImageUpload>
        </div>
        
      </div>

      <hr />

      <div class="row">
        <div class="col-12">
          <h5>{{ 'Solution' | translate }}</h5>
        </div>
        <div class="col-12 mb-3">
          <QuillInputS
            name="solution"
            display-name=""
            placeholder="Solution tips here"
            :value="data.solution.quill"
            @quillChanged="solutionChanged"
          ></QuillInputS>
        </div>
        <div class="col-12">
          <ImageUpload
            context="component.data.solution_img"
            :file-path="data.solution_img"
            @uploadCompleted="storeFile('solution_img', $event)"
            @fileDeleted="deleteFile('solution_img')"
          ></ImageUpload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuillInputS from './../QuillInputS'
import ImageUpload from './../ImageUpload'
import route from './../../routes.js'

export default {
  props: ['component', 'editing'],
  components: {
    QuillInputS,
    ImageUpload,
  },
  data() {
    return {
      data: this.component.data,
    }
  },
  updated() {
    this.updatecomponent()
  },
  methods: {
    deleteFile(type) {
      _.set(this.component, `data.${type}`, null)
      this.$emit('fileDeleted')
    },
    storeFile(type, filePath) {
      _.set(this.component, `data.${type}`, filePath)
      this.$emit('fileUploaded')
    },
    assignmentChanged(html, quill) {
      this.data.assignment.quill = quill
      this.data.assignment.html = html
    },
    solutionChanged(html, quill) {
      this.data.solution.quill = quill
      this.data.solution.html = html
    },
    updatecomponent() {
      this.component.data = this.data
    },
    textOnly(text) {
      return text
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .substr(0, 200)
    },
  },
}
</script>
